export function statisticsSlider() {
    const $statisticsSlider = $(".statistics-slider");
    $statisticsSlider.each(function () {
        let $this = $(this);
        let itemasLength = $this.find(".statistics-item").length;
        let slideShow = 4;
        if (itemasLength < slideShow) {
            slideShow = itemasLength;
        }
        // if ($this.hasClass("colored-list")) {
        //     slideShow = 3;
        // }
        // if ($this.parents(".section-with-bg").length) {
        //     slideShow = 3;
        // }

        $this.slick({
            slidesToScroll: 1,
            slidesToShow: 1.75,
            mobileFirst: true,
            infinite: false,
            arrows: false,
            dots: true,
            responsive: [
                {
                    breakpoint: 567,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 1023,
                    settings: {
                        slidesToShow: slideShow
                    }
                }
            ]
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/statisticsSlider.js